export const environment = {
  production: true,
  oauth_client_id: '6W8y1Xk1qyU5OhlfmfPEaXqIiMruh4L4UW4bJ83Z',
  oauth_endpoint: 'https://acceptance.wegwijzerdenhaag.nl',
  graphql_endpoint: 'https://acceptance.wegwijzerdenhaag.nl/nieuwkomer/api/graphql',
  wegwijzer_url: 'https://acceptance.wegwijzerdenhaag.nl/',
  api_endpoint: 'https://acceptance.wegwijzerdenhaag.nl/nieuwkomer/api',
};
